import React, { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import "../../assets/scss/pages/_assign-work.scss";
import MultipleDownloadfile from "../common/multiple-downloadfile";
import { setStringFileNameToArray, TransformColumnToArray } from "../utils/format-value";
import ConfigData from "../../config.json";
import axios from "axios";
import Swal from "sweetalert2";
import DownloadPDF from "../common/pdf-download";
import { IconLoading } from "../common/popup-alert";
import { ConvertFormatDate, ConvertFormatDateDash, ConvertFormatDateSlash } from "../utils/convert-date";
import { formatNumberWithComma } from '../utils/check-value';

const AssignDetailDbd = ({ requestDetail, requestTemplateDetail }) => {

  const modelAddFormBranch = { branchoffice_ic_location: '', branchoffice_ic_tel: '', branchoffice_ic_email: '', branchoffice_ic_fax: '', branchoffice_ic_file: '', file_branchoffice_ic_file: '' };
  const modelCloseFormBranch = { branchoffice_dc_location: '' };
  const modelEditFormBranch = { branchoffice_edit_clocation: '', branchoffice_edit_nlocation: '' };
  const modelCtp = { ts_ctp_transferor: '', ts_ctp_transferee: '', ts_ctp_amountshare: '', ts_ctp_pershare: '', ts_ctp_totalshare: '', ts_ctp_paydate: '', ts_ctp_file: '', file_ts_ctp_file: '' }
  const modelCodOut = { cod_out_name: '', cod_out_name_en: '' }
  const modelCodAdd = { cod_add_name: '', cod_add_name_en: '', cod_add_tel: '', cod_add_email: '', cod_add_file: '', file_cod_add_file: '' }

  const accessToken = localStorage.getItem("tkd");
  const [requestType, setRequestType] = useState([]);
  const [subRequestType, setSubRequestType] = useState([]);
  const [userDetail, setUserDetail] = useState([]);
  const [userBuDetail, setUserBuDetail] = useState([]);
  const [userCreateRequest, setUserCreateRequest] = useState([]);
  const [editSeal, setEditSeal] = useState([]);
  const [headofficeFile, setHeadofficeFile] = useState([]);
  const [objectiveAddFile, setObjectiveAddFile] = useState([]);
  const [objectiveEditFile, setObjectiveEditFile] = useState([]);
  const [bylawsAddFile, setBylawsAddFile] = useState([]);
  const [bylawsEditFile, setBylawsEditFile] = useState([]);

  const [dtcLiquidatorofficeFile, setDtcLiquidatorofficeFile] = useState([]);
  const [colBalancesheetFile, setColBalancesheetFile] = useState([]);
  const [colDocsFile, setColDocsFile] = useState([]);
  const [lastNumber, setLastNumber] = useState(0);
  const [dccapReducapTypeName, setDccapReducapTypeName] = useState("");

  const [formAddBranchOffice, setFormAddBranchOffice] = useState([]);
  const [formCloseBranchOffice, setFormCloseBranchOffice] = useState([]);
  const [formEditBranchOffice, setFormEditBranchOffice] = useState([]);
  const [formTsCtp, setFormTsCtp] = useState([]);
  const [formCodOut, setFormCodOut] = useState([]);
  const [formCodAdd, setFormCodAdd] = useState([]);

  const optionDccapReducapType = [
      { value: "1", label: "ลดจำนวนหุ้นลง (Decreasing number of)" },
      { value: "2", label: "ลดมูลค่าหุ้นลง ( Reduction of the par value)" },
  ];

  useEffect(() => {
    showLoading(true);
    LoadRequestType(requestTemplateDetail.id_request_type);
    LoadSubRequestType(requestTemplateDetail.id_sub_request_type);
    LoadUserInfo(requestDetail.request_by);
    LoadUserCreateRequest(requestDetail.create_request_by);
    if (Object.keys(requestTemplateDetail).length > 0) {
      setDccapReducapTypeName(
        optionDccapReducapType.find(
          (item) => item.value === requestTemplateDetail?.dccap_reducap_type
        )?.label
      );
    }
    let arrFormAddBranchOffice = TransformColumnToArray(requestTemplateDetail, modelAddFormBranch, 5);
    arrFormAddBranchOffice = (arrFormAddBranchOffice === null) ? [] : arrFormAddBranchOffice.map(item => ({...item, source: 'doc_add_branch'}));
    let arrFormCloseBranchOffice = TransformColumnToArray(requestTemplateDetail, modelCloseFormBranch, 5);
    arrFormCloseBranchOffice = (arrFormCloseBranchOffice === null) ? [] : arrFormCloseBranchOffice.map(item => ({...item, source: 'doc_close_branch'}));
    let arrFormEditBranchOffice = TransformColumnToArray(requestTemplateDetail, modelEditFormBranch, 5);
    arrFormEditBranchOffice = (arrFormEditBranchOffice === null) ? [] : arrFormEditBranchOffice.map(item => ({...item, source: 'doc_edit_branch'}));
    
    let arrTsCtp = TransformColumnToArray(requestTemplateDetail, modelCtp, 5);
    arrTsCtp = (arrTsCtp === null) ? [] : arrTsCtp.map(item => ({...item, source: 'doc_ctp'}));

    let arrCodOut = TransformColumnToArray(requestTemplateDetail, modelCodOut, 10);
    arrCodOut = (arrCodOut === null) ? [] : arrCodOut.map(item => ({...item, source: 'doc_cod_out'}));
    let arrCodAdd = TransformColumnToArray(requestTemplateDetail, modelCodAdd, 10);
    arrCodAdd = (arrCodAdd === null) ? [] : arrCodAdd.map(item => ({...item, source: 'doc_cod_add'}));

    setFormAddBranchOffice(arrFormAddBranchOffice);
    setFormCloseBranchOffice(arrFormCloseBranchOffice);
    setFormEditBranchOffice(arrFormEditBranchOffice);
    setFormTsCtp(arrTsCtp);
    setFormCodOut(arrCodOut);
    setFormCodAdd(arrCodAdd);
    LoadAllAttachment();
    CheckSectionSelected();
    showLoading(false);
  }, [requestDetail, requestTemplateDetail]);

  const [isShowSection, setIsShowSection] = useState({
      iccap_select: "0",
      dccap_select: "0",
      edit_name_select: "0",
      edit_seal_select: "0",
      headoffice_select: "0",
      branchoffice_select: "0",
      objective_select: "0",
      bylaws_select: "0",
      cod_select: "0",
      coa_select: "0",
      ts_select: "0",
      dtc_select: "0",
      col_select: "0",
      other_select: "0",
  });

  const onShowSection = () => {
    setIsShowSection(prevState => {
        const updatedState = Object.keys(prevState).reduce((acc, key) => {
            acc[key] = "1"; // ตั้งค่าทุก key เป็น "1"
            return acc;
        }, {});
        //console.log(updatedState);
        return updatedState;
    });
  }

  const toggleCheckbox = (checkboxKey) => {
      setIsShowSection((prevState) => ({
          ...prevState,
          [checkboxKey]: prevState[checkboxKey] === "1" ? "0" : "1",
      }));
  };

  const showLoading = (isShow) => {
    if (isShow) {
      Swal.fire({
        iconHtml: IconLoading,
        title: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  };

  const LoadAllAttachment = () => {
    if (Object.keys(requestTemplateDetail).length > 0) {
      setEditSeal(setStringFileNameToArray(requestTemplateDetail.edit_seal));
      setHeadofficeFile(setStringFileNameToArray(requestTemplateDetail.headoffice_file));
      setObjectiveAddFile(setStringFileNameToArray(requestTemplateDetail.objective_add_file));
      setObjectiveEditFile(setStringFileNameToArray(requestTemplateDetail.objective_edit_file));
      setBylawsAddFile(setStringFileNameToArray(requestTemplateDetail.bylaws_add_file));
      setBylawsEditFile(setStringFileNameToArray(requestTemplateDetail.bylaws_edit_file));
      
      setDtcLiquidatorofficeFile(setStringFileNameToArray(requestTemplateDetail.dtc_liquidatoroffice_file));
      setColBalancesheetFile(setStringFileNameToArray(requestTemplateDetail.col_balancesheet_file));
      setColDocsFile(setStringFileNameToArray(requestTemplateDetail.col_docs_file));
    }
  };

  //#region Call APIs

  const LoadRequestType = (requestTypeId) => {
    if (typeof requestTypeId === "undefined" || requestTypeId === null) {
      return;
    }
    let url = ConfigData.API_URL + "request-type/" + requestTypeId;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setRequestType(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadSubRequestType = (subRequestTypeId) => {
    if (typeof subRequestTypeId === "undefined" || subRequestTypeId === null) {
      return;
    }
    let url = ConfigData.API_URL + "sub-request-type/" + subRequestTypeId;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setSubRequestType(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadUserInfo = (email) => {
    let url = ConfigData.API_URL + "user/search?email=" + email;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setUserDetail(respData.data[0]);
          LoadUserBuInfo(respData.data[0].id_business_unit);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadUserBuInfo = (buId) => {
    let url = ConfigData.API_URL + "business-unit/" + buId;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setUserBuDetail(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadUserCreateRequest = (email) => {
      //console.log(email);
      let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
      let token = "Bearer " + localStorage.getItem("tkd");
      axios.get(url, { headers: { 
          'Authorization' : token ,
      }, responseType: "json" })
      .then(resp => {
          let respData = resp.data;
          // console.log(respData);
          if(respData.is_sucess === true && respData.data.length > 0){
              setUserCreateRequest(respData.data[0]);
          }
      })
      .catch(error => {
          // handlerRespError(error, history);
          console.log(error);
      });
  };

  //#endregion Call APIs

  const CheckSectionSelected = () => {
    const fields = [
      "iccap_select",
      "dccap_select",
      "edit_name_select",
      "edit_seal_select",
      "headoffice_select",
      "branchoffice_select",
      "objective_select",
      "bylaws_select",
      "cod_select",
      "coa_select",
      "ts_select",
      "dtc_select",
      "col_select",
      "other_select",
    ];
  
    // let totalSelected = 3; // เริ่มต้นที่ 3
    let count = 0; // ตัวนับจำนวนการเจอ "1"
    let nameShowSection = "";
    for (let i = 0; i < fields.length; i++) {
      const key = fields[i];
      if (requestTemplateDetail[key] === "1") {
        // totalSelected = 3 + count; // บวกตามจำนวนที่เจอ
        count++; // เพิ่มจำนวนการเจอ "1"
        nameShowSection = key;
      }
    }
    if(count === 1){
      setIsShowSection((prev) => ({
        ...prev,
        [nameShowSection]: "1"
      }));
    }
    setLastNumber(count);
    //console.log("totalSelected =", totalSelected);
    
  }

  const SwitchUserDetail = () => {
    switch (userDetail.business_unit?.toLowerCase()) {
      case "bts group holdings public company limited":
        return (
          <>
          {/* <div className="header-content">
              ข้อมูลของผู้ทำคำขอ (User Information)
          </div> */}
          <Col xl={12}>
              <Row>
                  <Col md={10}>
                    <div className="header-content">
                        ข้อมูลของผู้ทำคำขอ (User Information)
                    </div>
                  </Col>
                  <Col md={2}>
                      <div id="section-page-hide-input" className="header-form">
                          <span>
                              <Label htmlFor="export-pdf" className="form-export-file-label" onClick={() => { onShowSection()}}>
                                  <i className="mdi mdi-upload i-upload"></i>
                                  Export
                              </Label>
                          </span>
                      </div>
                  </Col>
              </Row>
          </Col>
          <Col md={12}>
            <div className="dashed-line"></div>
            <Row>
              <Col md={5}>
                <div className="body-content">
                  <Label className="content-name">
                    คำขอเลขที่ (Request No.)
                  </Label>
                  <Label className="content-val">
                    {requestDetail.request_no || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    ผู้ทำคำขอ (User’s Request)
                  </Label>
                  <Label className="content-val">
                    {userDetail.name + " " + userDetail.surname || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    บริษัทที่สังกัด (User's BU)
                  </Label>
                  <Label className="content-val">
                    {userBuDetail.name_en || "-"}
                  </Label>
                </div>
              </Col>
              <Col md={2}></Col>
              <Col md={5}>
                <div className="body-content">
                  <Label className="content-name">
                    วันที่สร้างคำขอ (Date of Request)
                  </Label>
                  <Label className="content-val">
                    {requestDetail.request_date || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    อีเมลผู้ทำคำขอ (User’s email)
                  </Label>
                  <Label className="content-val">
                    {userDetail.email || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    แผนกที่สังกัด (User's Department)
                  </Label>
                  <Label className="content-val">
                    {userDetail.department || "-"}
                  </Label>
                </div>
              </Col>
            </Row>
          </Col>
          </>
        );
      default:
        return(
          <>
          <Col xl={12}>
                <Row>
                    <Col md={10}>
                      <div className="header-content">
                          ข้อมูลของผู้ทำคำขอ (User Information)
                      </div>
                    </Col>
                    <Col md={2}>
                        <div id="section-page-hide-input" className="header-form">
                            <span>
                                <Label htmlFor="export-pdf" className="form-export-file-label" onClick={() => { onShowSection()}}>
                                    <i className="mdi mdi-upload i-upload"></i>
                                    Export
                                </Label>
                            </span>
                        </div>
                    </Col>
                </Row>
            </Col>
            {/* <div className="header-content">
                ข้อมูลของผู้ทำคำขอ (User Information)
            </div> */}
            <Col md={12}>
              <div className="dashed-line"></div>
              <Row>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      คำขอเลขที่ (Request No.)
                    </Label>
                    <Label className="content-val">
                      {requestDetail.request_no || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      ผู้ทำคำขอ (User’s Request)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.name + " " + userCreateRequest.surname || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      บริษัทที่สังกัด (User's BU)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.business_unit || "-"}
                    </Label>
                  </div>
                </Col>
                <Col md={2}></Col>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      วันที่สร้างคำขอ (Date of Request)
                    </Label>
                    <Label className="content-val">
                      {requestDetail.request_date || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      อีเมลผู้ทำคำขอ (User’s email)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.email || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      แผนกที่สังกัด (User's Department)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.department || "-"}
                    </Label>
                  </div>
                </Col>
              </Row>
            </Col>
            <div className="header-content">
              ข้อมูลของผู้ประสานงาน (User Coordinator Information)
            </div>
            <Col md={12}>
              <div className="dashed-line"></div>
              <Row>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      ผู้ประสานงาน (User’s Coordinator Request)
                    </Label>
                    <Label className="content-val">
                      {userDetail.name + " " + userDetail.surname || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      บริษัทที่สังกัด (User's BU)
                    </Label>
                    <Label className="content-val">
                      {userBuDetail.name_en || "-"}
                    </Label>
                  </div>
                </Col>
                <Col md={2}></Col>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      อีเมลผู้ประสานงาน (User’s coordinator email)
                    </Label>
                    <Label className="content-val">
                      {userDetail.email || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      แผนกที่สังกัด (User's Department)
                    </Label>
                    <Label className="content-val">
                      {userDetail.department || "-"}
                    </Label>
                  </div>
                </Col>
              </Row>
            </Col>
          </>
        );
    }
  };

  const RenderAddFormBranch = (data, index, showLabelNumber) => {
      return (
        <>
        <Row id="section-page-8-2">
          <Col md={12}>
            <div className="body-content">
              {index === 0 && (
                <Label className="content-val">เพิ่มสาขา (Adding the new branch office)</Label>
              )}
              {showLabelNumber && (
                <Label className="label-title-number-section-view">สาขาที่ {index + 1}.</Label>
              )}
              <Label className="content-name">ที่ตั้งสาขา (Address)</Label>
              <Label className="content-val word-wrap">{data.branchoffice_ic_location || "-"}</Label>
            </div>
          </Col>
        </Row>
        <Row id="section-page-8-3">
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">เบอร์โทรศัพท์ (Telephone Number)</Label>
              <Label className="content-val">{data.branchoffice_ic_tel || "-"}</Label>
            </div>
          </Col>
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">อีเมล (Email)</Label>
              <Label className="content-val">{data.branchoffice_ic_email || "-"}</Label>
            </div>
          </Col>
        </Row>
        <Row id="section-page-8-4">
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">โทรสาร (Fax)</Label>
              <Label className="content-val">{data.branchoffice_ic_fax || "-"}</Label>
            </div>
          </Col>
          <Col md={6}></Col>
        </Row>
        <Row id="section-page-8-5">
          <Col md={12}>
            <div className="body-content">
              <Label className="content-name">แนบไฟล์ทะเบียนบ้านที่ตั้งใหม่(Attach the new house registration)</Label>
              {setStringFileNameToArray(data.branchoffice_ic_file).length > 0 ? (
                <MultipleDownloadfile
                  folder={requestDetail.request_no}
                  dataFile={setStringFileNameToArray(data.branchoffice_ic_file)}
                />
              ) : (
                <div>-</div>
              )}
            </div> 
          </Col>
        </Row>
        </>
      );
  };

  const RenderCloseFormBranch = (data, index, showLabelNumber) => {
      return (
        <>
          <Row id="section-page-8-6">
            <Col md={12}>
              <div className="body-content">
                {index === 0 && (
                  <Label className="content-val">ลดสาขา (Closing the branch office)</Label>
                )}
                {showLabelNumber && (
                  <Label className="label-title-number-section-view">สาขาที่ {index + 1}.</Label>
                )}
                <Label className="content-name">ที่ตั้งสาขา (Address)</Label>
                <Label className="content-val word-wrap">{data.branchoffice_dc_location || "-"}</Label>
              </div>
            </Col>
          </Row>
        </>
      );
  };

  const RenderEditFormBranch = (data, index, showLabelNumber) => {
    return (
        <>
          <Row id="section-page-8-7">
            <Col md={12}>
              <div className="body-content">
                {index === 0 && (
                  <Label className="content-val">แก้ไขสาขา (Amendment of the branch office address)</Label>
                )}
                {showLabelNumber && (
                  <Label className="label-title-number-section-view">สาขาที่ {index + 1}.</Label>
                )}
                <Label className="content-name">ที่ตั้งสาขาปัจจุบัน (Present address)</Label>
                <Label className="content-val word-wrap">{data.branchoffice_edit_clocation || "-"}</Label>
              </div>
              <div className="body-content">
                <Label className="content-name">ที่ตั้งสาขาใหม่ (New address)</Label>
                <Label className="content-val word-wrap">{data.branchoffice_edit_nlocation || "-"}</Label>
              </div>
            </Col>
          </Row>
        </>
    );
  };

  const RenderTsCtp = (data, index) => {
    return (
      <>
      <Col md={12}>
          <Row>
            <div className="body-content">
              <Label className="label-title-number-section-view">คู่สัญญาที่ {index + 1} The contracting party No.{index + 1}</Label>
              <Label className="content-name">ชื่อผู้โอน (Transferor)</Label>
              <Label className="content-val word-wrap">{data.ts_ctp_transferor || "-"}</Label>
            </div>
          </Row>
          <Row>
            <div className="body-content">
              <Label className="content-name">ชื่อผู้รับโอน (Transferee)</Label>
              <Label className="content-val word-wrap">{data.ts_ctp_transferee || "-"}</Label>
            </div>
          </Row>
          <Row>
            <div className="body-content">
              <Label className="content-name">ประเภทหุ้นและจำนวนหุ้นที่โอน (Type and total of share transferred)</Label>
              <Label className="content-val word-wrap">{data.ts_ctp_amountshare || "-"}</Label>
            </div>
          </Row>
      </Col>
        <Row>
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">ราคาซื้อขายหุ้นละ/บาท (Transfer price of each share)</Label>
              <Label className="content-val">{formatNumberWithComma(data.ts_ctp_pershare) || "-"}</Label>
            </div>
          </Col>
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">รวมราคาซื้อขายทั้งสิ้น/บาท (The total of transfer price)</Label>
              <Label className="content-val">{formatNumberWithComma(data.ts_ctp_totalshare) || "-"}</Label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">จ่ายเงินวันที่ (Payment date)</Label>
              <Label className="content-val">{ ConvertFormatDateSlash(data.ts_ctp_paydate) || "-"}</Label>
            </div>
          </Col>
          <Col md={6}></Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="body-content">
              <Label className="content-name">ไฟล์สำเนาบัตรประชาชน/หนังสือเดินทางและ ใบอนุญาตทำงาน/หนังสือรับรองบริษัทของผู้โอนและ ผู้รับโอน <br/>The copy (.pdf) of Thai National ID Card / Passport and Work Permit / Affidavit of the transferor and transferee</Label>
              <Label className="content-val">
              {setStringFileNameToArray(data.ts_ctp_file).length > 0 ? (
                <MultipleDownloadfile
                  folder={requestDetail.request_no}
                  dataFile={setStringFileNameToArray(data.ts_ctp_file)}
                />
              ) : (
                <div>-</div>
              )}
              </Label>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const RenderCodOut = (data, index) => {
    return (
      <> 
        <Row>
          <Col md={12}>
            <div className="body-content margin-bottom-10">
              <Label className="content-name">1.{index + 1} คำนำหน้า ชื่อและนามสกุลภาษาไทย (Name-Surname in Thai)</Label>
              <Label className="content-val word-wrap">{data.cod_out_name || "-"}</Label>
            </div>
            <div className="body-content margin-bottom-10">
              <Label className="content-name">คำนำหน้า ชื่อและนามสกุลภาษาอังกฤษ (Name-Surname in English)</Label>
              <Label className="content-val word-wrap">{data.cod_out_name_en || "-"}</Label>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const RenderCodAdd = (data, index) => {
    return (
      <>
        <Row>
          <Col md={12}>
            <div className="body-content margin-bottom-10">
              <Label className="content-name">2.{index + 1} คำนำหน้า ชื่อและนามสกุลภาษาไทย (Name-Surname in Thai)</Label>
              <Label className="content-val word-wrap">{data.cod_add_name || "-"}</Label>
            </div>
            <div className="body-content margin-bottom-10">
              <Label className="content-name">คำนำหน้า ชื่อและนามสกุลภาษาอังกฤษ (Name-Surname in English)</Label>
              <Label className="content-val word-wrap">{data.cod_add_name_en || "-"}</Label>
            </div>
          </Col>
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">เบอร์โทรศัพท์ (Telephone No.)</Label>
              <Label className="content-val word-wrap">{data.cod_add_tel || "-"}</Label>
            </div>
          </Col>
          <Col md={6}>
            <div className="body-content">
              <Label className="content-name">อีเมล (Email)</Label>
              <Label className="content-val word-wrap">{data.cod_add_email || "-"}</Label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="body-content no-margin-bottom">
              <Label className="content-name">ไฟล์สำเนาบัตรประชาชน/หนังสือเดินทาง (Passport) และ Work Permit<br/>The copy (.pdf) of Thai National ID Card / Passport and Work permit</Label>
              <Label className="content-val">
              {setStringFileNameToArray(data.cod_add_file).length > 0 ? (
                <MultipleDownloadfile
                  folder={requestDetail.request_no}
                  dataFile={setStringFileNameToArray(data.cod_add_file)}
                />
              ) : (
                <div>-</div>
              )}
              </Label>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <React.Fragment>
        <Row>
          <Col xl={12} className="mx-auto">
          <DownloadPDF fileName={`form-dbd-${requestDetail.request_no}.pdf`} type={"formLabel"}>
            <div className="page-content-assign">
              <Row id="section-page-1-1">
                {SwitchUserDetail()}
                <div className="header-content">
                  ข้อมูลทั่วไป (Request General Information)
                </div>
                <Col md={12}>
                  <div className="dashed-line"></div>
                  <Row>
                    <Col md={5}>
                      <div className="body-content">
                        <Label className="content-name">ประเภทคำขอ (Type of Request)</Label>
                        <Label className="content-val">
                          {requestType.name_en || "-"}
                        </Label>
                      </div>
                    </Col>
                    <Col md={2}></Col>
                    <Col md={5}>
                      <div className="body-content">
                        <Label className="content-name">เรื่อง (Matters)</Label>
                        <Label className="content-val">
                          {subRequestType.name_en || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="body-content">
                        <Label className="content-name">
                          บริษัท (Name of the Company)
                        </Label>
                        <Label className="content-val">
                          {requestTemplateDetail.name_businessunit || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row id="section-page-2-1">
                <div className="header-content header-label-pdf">เรื่องที่จะขอจดทะเบียน (Registration Request)</div>
                <Col md={12}>
                  <div className="dashed-line"></div>
                </Col>
              </Row>
                  { requestTemplateDetail.iccap_select === "1" && (
                    <>
                      <Row id="section-page-3-1">
                          <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("iccap_select")}>
                              <i className="mdi mdi-book-open-variant icon-book"></i>
                              <Label className="label-title-topic">เพิ่มทุน</Label>
                              <br/>
                              <Label className="label-sub-title-topic">(Increase Registered Capital)</Label>
                          </Col>
                      </Row>
                          { isShowSection.iccap_select === "1" && (
                              <>
                                  <Row id="section-page-3-2">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">1.ทุนจดทะเบียนปัจจุบัน (Existing registered capital)</Label>
                                        <Label className="content-name">ทุนจดทะเบียนปัจจุบัน/บาท (Existing registered capital/Baht)</Label>
                                        <Label className="content-val">{formatNumberWithComma(requestTemplateDetail.iccap_regiscap_amount) || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-3">
                                    <Col md={6}>
                                        <div className="body-content">
                                          <Label className="content-name">
                                          จำนวนหุ้นสามัญ (Number of ordinary shares)
                                          </Label>
                                          <Label className="content-val">
                                            {formatNumberWithComma(requestTemplateDetail.iccap_regiscap_commonstock) || "-"}
                                          </Label>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="body-content">
                                          <Label className="content-name">
                                          จำนวนหุ้นบุริมสิทธิ (Number of preferred shares)
                                          </Label>
                                          <Label className="content-val">
                                            {formatNumberWithComma(requestTemplateDetail.iccap_regiscap_preferredstock) || "-"}
                                          </Label>
                                        </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-4">
                                    <Col md={6}>
                                      <div className="body-content">
                                        <Label className="content-name">
                                        มูลค่าหุ้นละ/บาท (Par value)
                                        </Label>
                                        <Label className="content-val">
                                          {formatNumberWithComma(requestTemplateDetail.iccap_regiscap_valuepershare) || "-"}
                                        </Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-5">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">2.ทุนส่วนที่จะเพิ่ม (Additional registered capital)</Label>
                                        <Label className="content-name">ทุนส่วนที่จะเพิ่ม/บาท (Additional registered capital/Baht)</Label>
                                        <Label className="content-val">{formatNumberWithComma(requestTemplateDetail.iccap_addcap_amount) || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-6">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-name">
                                        จำนวนหุ้นสามัญที่เพิ่ม (Number of additional ordinary shares)
                                        </Label>
                                        <Label className="content-val">
                                          {formatNumberWithComma(requestTemplateDetail.iccap_addcap_commonstock) || "-"}
                                        </Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-7">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-name">
                                        จำนวนหุ้นบุริมสิทธิที่เพิ่ม (Number of additional preferred shares)
                                        </Label>
                                        <Label className="content-val">
                                          {formatNumberWithComma(requestTemplateDetail.iccap_addcap_preferredstock) || "-"}
                                        </Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-8">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-name">การจองซื้อหุ้นของผู้ถือหุ้นแต่ละรายและระบุจำนวนหุ้น<br/>
                                        (Proportion of share subscriptions for each shareholder and specify the number of shares)
                                        </Label>
                                        <Label className="content-val label-text-area">{requestTemplateDetail.iccap_addcap_valuepershare || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-9">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">3.ทุนจดทะเบียนใหม่ (Newly registered capital)</Label>
                                        <Label className="content-name">ทุนจดทะเบียนใหม่/บาท (Newly registered capital/Baht)</Label>
                                        <Label className="content-val">{formatNumberWithComma(requestTemplateDetail.iccap_newcap_amount) || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-10">
                                    <Col md={6}>
                                      <div className="body-content">
                                        <Label className="content-name">
                                        จำนวนหุ้นสามัญใหม่ (Number of new ordinary shares)
                                        </Label>
                                        <Label className="content-val">
                                          {formatNumberWithComma(requestTemplateDetail.iccap_newcap_stock) || "-"}
                                        </Label>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="body-content">
                                        <Label className="content-name">
                                        จำนวนหุ้นบุริมสิทธิใหม่ (Number of new preferred shares)
                                        </Label>
                                        <Label className="content-val">
                                          {formatNumberWithComma(requestTemplateDetail.iccap_newcap_valuepershare) || "-"}
                                        </Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-11">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">4.เรียกชำระครั้งแรก (The first payment)</Label>
                                        <Label className="content-name">เรียกชำระครั้งแรก หุ้นละ/บาท (The first payment per share)</Label>
                                        <Label className="content-val">{formatNumberWithComma(requestTemplateDetail.iccap_paymentpershare) || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-12">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">5.ชำระเงิน (Payment)</Label>
                                        <Label className="content-name">วันที่ชำระเงิน/บาท (Payment date)</Label>
                                        <Label className="content-val">{ ConvertFormatDate(requestTemplateDetail.iccap_paymentdate) || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-13">
                                    <Col md={6}>
                                      <div className="body-content">
                                        <Label className="content-val">6.บัญชีที่เงินเข้า (Bank account)<br/></Label>
                                        <Label className="content-name">เงินเข้าบัญชีธนาคาร (Bank Account)</Label>
                                        <Label className="content-val">{requestTemplateDetail.iccap_bank_account || "-"}</Label>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="body-content">
                                        <Label className="content-val"><br/></Label>
                                        <Label className="content-name">ชื่อบัญชี (Account Name)</Label>
                                        <Label className="content-val">{requestTemplateDetail.iccap_bank_name || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-3-14">
                                    <Col md={6}>
                                      <div className="body-content">
                                        <Label className="content-name">เลขที่บัญชี (Account No.)</Label>
                                        <Label className="content-val">{requestTemplateDetail.iccap_bank_no || "-"}</Label>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="body-content">
                                        <Label className="content-name">สาขา (Branch)</Label>
                                        <Label className="content-val">{requestTemplateDetail.iccap_bank_branch || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                              </>
                          )}
                          {((isShowSection.iccap_select === "0" ) ||
                            (isShowSection.iccap_select === "1" && lastNumber > 1)) && (
                            <Row id="section-page-3-15">
                              <Col md={12}>
                                  <div className="section-dashed-line"></div>
                              </Col>
                            </Row>
                          )}
                        
                    </>
                  )}
                  { requestTemplateDetail.dccap_select === "1" && (
                    <>
                      <Row id="section-page-4-1">
                          <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("dccap_select")}>
                              <i className="mdi mdi-book-open-variant icon-book"></i>
                              <Label className="label-title-topic">ลดทุน</Label>
                              <br/>
                              <Label className="label-sub-title-topic">(Decrease Registered Capital)</Label>
                          </Col>
                      </Row>
                            { isShowSection.dccap_select === "1" && (
                                <>
                                    <Row id="section-page-4-2">
                                      <Col md={12}>
                                        <div className="body-content">
                                          <Label className="content-val">1.ทุนจดทะเบียนปัจจุบัน (Existing registered capital)</Label>
                                          <Label className="content-name">ทุนจดทะเบียนปัจจุบัน/บาท (Existing registered capital is/Baht)</Label>
                                          <Label className="content-val">{formatNumberWithComma(requestTemplateDetail.dccap_regiscap_amount) || "-"}</Label>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row id="section-page-4-3">
                                      <Col md={6}>
                                          <div className="body-content">
                                            <Label className="content-name">
                                            จำนวนหุ้นสามัญ (Number of ordinary shares)
                                            </Label>
                                            <Label className="content-val">
                                              {formatNumberWithComma(requestTemplateDetail.dccap_regiscap_commonstock) || "-"}
                                            </Label>
                                          </div>
                                      </Col>
                                      <Col md={6}>
                                          <div className="body-content">
                                            <Label className="content-name">
                                            จำนวนหุ้นบุริมสิทธิ (Number of preferred shares)
                                            </Label>
                                            <Label className="content-val">
                                              {formatNumberWithComma(requestTemplateDetail.dccap_regiscap_preferredstock) || "-"}
                                            </Label>
                                          </div>
                                      </Col>
                                      <Col md={6}>
                                          <div className="body-content">
                                            <Label className="content-name">
                                            มูลค่าหุ้นละ/บาท (Par value)
                                            </Label>
                                            <Label className="content-val">
                                              {formatNumberWithComma(requestTemplateDetail.dccap_regiscap_valuepershare) || "-"}
                                            </Label>
                                          </div>
                                      </Col>
                                    </Row>
                                    <Row id="section-page-4-4">
                                      <Col md={12}>
                                        <div className="body-content">
                                          <Label className="content-val">2.ทุนจดทะเบียนส่วนที่ลดลง (Decrease registered capital)</Label>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row id="section-page-4-5">
                                      <Col md={6}>
                                        <div className="body-content decress-content">
                                          <Label className="content-name">ทุนจดทะเบียนส่วนที่ลดลง/บาท (Decrease registered capital/Baht)</Label>
                                          <Label className="content-val">{formatNumberWithComma(requestTemplateDetail.dccap_reducap_amount) || "-"}</Label>
                                        </div>
                                      </Col>
                                      <Col md={6}>
                                        <div className="body-content">
                                          <Label className="content-name">โดยการ</Label>
                                          <Label className="content-val">{dccapReducapTypeName || "-"}</Label>
                                        </div>
                                      </Col>
                                    </Row>
                                    { requestTemplateDetail?.dccap_reducap_type === "1" && (
                                      <>
                                        <Row id="section-page-4-6">
                                          <Col md={12}>
                                              <div className="body-content">
                                                <Label className="content-name">
                                                จำนวนหุ้นสามัญส่วนที่ลดลง (Number of ordinary shares decreased)
                                                </Label>
                                                <Label className="content-val">
                                                  {formatNumberWithComma(requestTemplateDetail.dccap_reducap_commonstock) || "-"}
                                                </Label>
                                              </div>
                                          </Col>
                                        </Row>
                                        <Row id="section-page-4-7">
                                          <Col md={12}>
                                              <div className="body-content">
                                                <Label className="content-name">
                                                จำนวนหุ้นบุริมสิทธิส่วนที่ลดลง (Number of preferred shares decreased)
                                                </Label>
                                                <Label className="content-val">
                                                  {formatNumberWithComma(requestTemplateDetail.dccap_reducap_preferredstock) || "-"}
                                                </Label>
                                              </div>
                                          </Col>
                                        </Row>
                                      </>
                                    )}
                                    { requestTemplateDetail?.dccap_reducap_type === "2" && (
                                      <>
                                        <Row id="section-page-4-6">
                                          <Col md={12}>
                                              <div className="body-content">
                                                <Label className="content-name">
                                                มูลค่าหุ้นส่วนที่ลดลงหุ้นละ/บาท (Reduction of the par value per share/Baht)
                                                </Label>
                                                <Label className="content-val">
                                                  {formatNumberWithComma(requestTemplateDetail.dccap_reducap_valuepershare) || "-"}
                                                </Label>
                                              </div>
                                          </Col>
                                        </Row>
                                      </>
                                    )}
                                    <Row id="section-page-4-8">
                                      <Col md={12}>
                                        <div className="body-content">
                                          <Label className="content-val">3.ทุนจดทะเบียนหลังการลดทุน (Registered capital after decrease)</Label>
                                          <Label className="content-name">ทุนจดทะเบียน/บาท (Registered capital/Baht)</Label>
                                          <Label className="content-val">{formatNumberWithComma(requestTemplateDetail.dccap_newcap_amount) || "-"}</Label>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row id="section-page-4-9">
                                      <Col md={6}>
                                          <div className="body-content">
                                            <Label className="content-name">
                                            จำนวนหุ้นสามัญ (Number of ordinary shares)
                                            </Label>
                                            <Label className="content-val">
                                              {formatNumberWithComma(requestTemplateDetail.dccap_newcap_commonstock) || "-"}
                                            </Label>
                                          </div>
                                      </Col>
                                      <Col md={6}>
                                          <div className="body-content">
                                            <Label className="content-name">
                                            จำนวนหุ้นบุริมสิทธิ (Number of preferred shares)
                                            </Label>
                                            <Label className="content-val">
                                              {formatNumberWithComma(requestTemplateDetail.dccap_newcap_preferredstock) || "-"}
                                            </Label>
                                          </div>
                                      </Col>
                                    </Row>
                                    <Row id="section-page-4-10">
                                      <Col md={6}>
                                          <div className="body-content">
                                            <Label className="content-name">
                                            ราคาหุ้นใหม่/บาท (New par value)
                                            </Label>
                                            <Label className="content-val">
                                              {formatNumberWithComma(requestTemplateDetail.dccap_newcap_valuepershare) || "-"}
                                            </Label>
                                          </div>
                                      </Col>
                                      <Col md={6}></Col>
                                    </Row>
                                    <Row id="section-page-4-11">
                                        <Col md={12}>
                                            <div className="body-content">
                                              <Label className="content-name">
                                              จำนวนการถือหุ้นภายหลังการลดทุน (The number of shares held after the capital reduction)
                                              </Label>
                                              <Label className="content-val">
                                                {requestTemplateDetail.dccap_after_reducap || "-"}
                                              </Label>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {((isShowSection.dccap_select === "0" ) ||
                              (isShowSection.dccap_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-4-12">
                                <Col md={12}>
                                    <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
                  { requestTemplateDetail.edit_name_select === "1" && (
                    <>
                      <Row id="section-page-5-1">
                        <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("edit_name_select")}>
                            <i className="mdi mdi-book-open-variant icon-book"></i>
                            <Label className="label-title-topic">แก้ไขชื่อ</Label>
                            <br/>
                            <Label className="label-sub-title-topic">(Amendment of the Company's Name)</Label>
                        </Col>
                      </Row>
                          { isShowSection.edit_name_select === "1" && (
                              <>
                                <Row id="section-page-5-2">
                                  <Col md={12}>
                                    <div className="body-content">
                                      <Label className="content-val">ชื่อใหม่บริษัท (New Name of The Company)</Label>
                                      <Label className="content-name">1.ชื่อภาษาไทย (Thai Name)</Label>
                                      <Label className="content-val word-wrap">{requestTemplateDetail.edit_name_th || "-"}</Label>
                                    </div>
                                    <div className="body-content">
                                      <Label className="content-name">2.ชื่อภาษาอังกฤษ (English Name)</Label>
                                      <Label className="content-val word-wrap">{requestTemplateDetail.edit_name_en || "-"}</Label>
                                    </div>
                                  </Col>
                                </Row>
                              </>
                          )}
                          {((isShowSection.edit_name_select === "0" ) ||
                            (isShowSection.edit_name_select === "1" && lastNumber > 1)) && (
                            <Row id="section-page-5-3">
                              <Col md={12}>
                                  <div className="section-dashed-line"></div>
                              </Col>
                            </Row>
                          )}
                    </>
                  )}
                  { requestTemplateDetail.edit_seal_select === "1" && (
                    <>
                      <Row id="section-page-6-1">
                        <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("edit_seal_select")}>
                          <i className="mdi mdi-book-open-variant icon-book"></i>
                          <Label className="label-title-topic">แก้ไขตราประทับบริษัท</Label>
                          <br/>
                          <Label className="label-sub-title-topic">(Amendment of the Company's Seal)</Label>
                        </Col>
                      </Row>
                            { isShowSection.edit_seal_select === "1" && (
                                <>
                                    <Row id="section-page-6-2">
                                      <Col md={12}>
                                        <div className="body-content">
                                          <Label className="content-name">สีน้ำหมึกของตราประทับบริษัท (Ink color for the Company’s seal)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.edit_seal_ink || "-"}</Label>
                                        </div>
                                        <div className="body-content">
                                          <Label className="content-name">แนบไฟล์ตราประทับบริษัท (File of the Company seal)</Label>
                                          {editSeal.length > 0 ? (
                                            <MultipleDownloadfile
                                              folder={requestDetail.request_no}
                                              dataFile={editSeal}
                                            />
                                          ) : (
                                            <div>-</div>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                </>
                            )}
                            {((isShowSection.edit_seal_select === "0" ) ||
                              (isShowSection.edit_seal_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-6-3">
                                <Col md={12}>
                                    <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
                  { requestTemplateDetail.headoffice_select === "1" && (
                    <>
                      <Row id="section-page-7-1">
                                <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("headoffice_select")}>
                                  <i className="mdi mdi-book-open-variant icon-book"></i>
                                  <Label className="label-title-topic">แก้ไขที่ตั้งสำนักงานใหญ่</Label>
                                  <br/>
                                  <Label className="label-sub-title-topic">(Amendment of the Head Office Address)</Label>
                                </Col>
                      </Row>
                            { isShowSection.headoffice_select === "1" && (
                                <>
                                    <Row id="section-page-7-2">
                                      <Col md={12}>
                                        <div className="body-content">
                                          <Label className="content-name">ที่ตั้งปัจจุบัน (Present address)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.headoffice_clocation || "-"}</Label>
                                        </div>
                                        <div className="body-content">
                                          <Label className="content-name">ที่ตั้งใหม่ภาษาไทย (New address in Thai)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.headoffice_nlocation_th || "-"}</Label>
                                        </div>
                                        <div className="body-content">
                                          <Label className="content-name">ที่ตั้งใหม่ภาษาอังกฤษ (New address in English)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.headoffice_nlocation_en || "-"}</Label>
                                        </div>
                                        <div className="body-content">
                                          <Label className="content-name">ไฟล์ทะเบียนบ้านที่ตั้งใหม่และแผนที่ (Attach the new house registration and map)</Label>
                                          {headofficeFile.length > 0 ? (
                                            <MultipleDownloadfile
                                              folder={requestDetail.request_no}
                                              dataFile={headofficeFile}
                                            />
                                          ) : (
                                            <div>-</div>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                </>
                            )}
                            {((isShowSection.headoffice_select === "0" ) ||
                              (isShowSection.headoffice_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-7-3">
                                <Col md={12}>
                                    <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
                  { requestTemplateDetail.branchoffice_select === "1" && (
                    <>
                      <Row id="section-page-8-1">
                          <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("branchoffice_select")}>
                            <i className="mdi mdi-book-open-variant icon-book"></i>
                            <Label className="label-title-topic">แก้ไขที่ตั้งสำนักงานสาขา </Label>
                            <br/>
                            <Label className="label-sub-title-topic">(Amendment of the Branch Office Address)</Label>
                          </Col>
                      </Row>
                      {isShowSection.branchoffice_select === "1" && (() => {
                        const selectedTypes = [];

                        if (requestTemplateDetail.branchoffice_ic_select === "1") {
                          selectedTypes.push("ic");
                        }
                        if (requestTemplateDetail.branchoffice_dc_select === "1") {
                          selectedTypes.push("dc");
                        }
                        if (requestTemplateDetail.branchoffice_edit_select === "1") {
                          selectedTypes.push("edit");
                        }

                        const showLabelNumber = selectedTypes.length > 1;

                        const renderGroup = (items, type, renderFunc) => {
                          const groupElements = [];
                          let index = 0;

                          items.forEach((item) => {
                            if (
                              (type === "ic" && item.source === "doc_add_branch") ||
                              (type === "dc" && item.source === "doc_close_branch") ||
                              (type === "edit" && item.source === "doc_edit_branch")
                            ) {
                              groupElements.push(
                                <Row key={`${type}-${index}`}>
                                  <Col md={12}>{renderFunc(item, index, showLabelNumber)}</Col>
                                </Row>
                              );
                              index++;
                            }
                          });

                          return groupElements;
                        };

                        const groupedSections = [];

                        if (selectedTypes.includes("ic")) {
                          groupedSections.push(renderGroup(formAddBranchOffice, "ic", RenderAddFormBranch));
                        }

                        if (selectedTypes.includes("dc")) {
                          groupedSections.push(renderGroup(formCloseBranchOffice, "dc", RenderCloseFormBranch));
                        }

                        if (selectedTypes.includes("edit")) {
                          groupedSections.push(renderGroup(formEditBranchOffice, "edit", RenderEditFormBranch));
                        }

                        return (
                          <>
                            {groupedSections.map((group, groupIdx) => (
                              <React.Fragment key={`group-${groupIdx}`}>
                                {group}
                                {/* ใส่เส้นคั่นระหว่างกลุ่ม */}
                                {groupIdx < groupedSections.length - 1 && (
                                  <div className="dashed-line my-3" />
                                )}
                              </React.Fragment>
                            ))}
                          </>
                        );
                      })()}
                      {((isShowSection.branchoffice_select === "0" ) ||
                        (isShowSection.branchoffice_select === "1" && lastNumber > 1)) && (
                        <Row id="section-page-8-8">
                          <Col md={12}>
                              <div className="section-dashed-line"></div>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                  { requestTemplateDetail.objective_select === "1" && (
                    <>
                      <Row id="section-page-9-1">
                        <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("objective_select")}>
                          <i className="mdi mdi-book-open-variant icon-book"></i>
                          <Label className="label-title-topic">แก้ไขวัตถุประสงค์ </Label>
                          <br/>
                          <Label className="label-sub-title-topic">(Amendment of the Company's Objectives))</Label>
                        </Col>
                      </Row>
                            { isShowSection.objective_select === "1" && (
                                <>
                                    { requestTemplateDetail.objective_add_select === "1" && (
                                        <>
                                            <Row id="section-page-9-2">
                                              <Col md={12}>
                                                <div className="body-content">
                                                  <Label className="content-val">เพิ่มวัตถุประสงค์ (ข้อใหม่) (Adding the new objective(s))</Label>
                                                  <Label className="content-name">แนบไฟล์ข้อความวัตถุประสงค์ที่ต้องการเพิ่ม (Attach the document in .doc format)</Label>
                                                  {objectiveAddFile.length > 0 ? (
                                                    <MultipleDownloadfile
                                                      folder={requestDetail.request_no}
                                                      dataFile={objectiveAddFile}
                                                    />
                                                  ) : (
                                                    <div>-</div>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                        </>
                                    )}  
                                    { requestTemplateDetail.objective_edit_select === "1" && (
                                        <>
                                            <Row id="section-page-9-3">
                                              <Col md={12}>
                                                <div className="body-content">
                                                  <Label className="content-val">แก้ไขวัตถุประสงค์ข้อเดิม (Amending the original objective(s))</Label>
                                                  <Label className="content-name">แนบไฟล์ข้อความวัตถุประสงค์ที่ต้องการแก้ไข (Attach the document in .doc format)</Label>
                                                  {objectiveEditFile.length > 0 ? (
                                                    <MultipleDownloadfile
                                                      folder={requestDetail.request_no}
                                                      dataFile={objectiveEditFile}
                                                    />
                                                  ) : (
                                                    <div>-</div>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                        </>
                                    )}
                                    { requestTemplateDetail.objective_main_select === "1" && (
                                        <>
                                            <Row id="section-page-9-4">
                                              <Col md={12}>
                                                <div className="body-content">
                                                  <Label className="content-val">วัตถุประสงค์หลัก (ระบุใน สสช.1) The main objective (specify in SSCH1 form)</Label>
                                                  <Label className="content-name">วัตถุประสงค์หลัก (The main objective)</Label>
                                                  <Label className="content-val word-wrap">{requestTemplateDetail.objective_main_other || "-"}</Label>
                                                </div>
                                              </Col>
                                            </Row>
                                        </>
                                    )}  
                                </>
                            )}
                            {((isShowSection.objective_select === "0" ) ||
                              (isShowSection.objective_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-9-5">
                                <Col md={12}>
                                    <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
                  { requestTemplateDetail.bylaws_select === "1" && (
                    <>
                      <Row id="section-page-10-1">
                          <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("bylaws_select")}>
                            <i className="mdi mdi-book-open-variant icon-book"></i>
                            <Label className="label-title-topic">แก้ไขข้อบังคับ</Label>
                            <br/>
                            <Label className="label-sub-title-topic">(Amendment of the Article of Association)  </Label>
                          </Col>
                      </Row>
                          { isShowSection.bylaws_select === "1" && (
                              <>
                                  { requestTemplateDetail.bylaws_add_select === "1" && (
                                      <>
                                          <Row id="section-page-10-2">
                                            <Col md={12}>
                                              <div className="body-content">
                                                <Label className="content-val">เพิ่มข้อบังคับ (ข้อใหม่) (Adding the new Article(s) of Association)</Label>
                                                <Label className="content-name">แนบไฟล์ข้อความที่ต้องการเพิ่ม (Attach the document in .doc format)</Label>
                                                {bylawsAddFile.length > 0 ? (
                                                  <MultipleDownloadfile
                                                    folder={requestDetail.request_no}
                                                    dataFile={bylawsAddFile}
                                                  />
                                                ) : (
                                                  <div>-</div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                      </>
                                  )}
                                  { requestTemplateDetail.bylaws_edit_select === "1" && (
                                      <>
                                          <Row id="section-page-10-3">
                                            <Col md={12}>
                                              <div className="body-content">
                                                <Label className="content-val">แก้ไขข้อบังคับข้อเดิม/เปลี่ยนทั้งฉบับ (Amending the original article(s)/<br/>replacing the entire original articles with the new articles)</Label>
                                                <Label className="content-name">แนบไฟล์ข้อความที่ต้องการแก้ไข (Attach the document in .doc format)</Label>
                                                {bylawsEditFile.length > 0 ? (
                                                  <MultipleDownloadfile
                                                    folder={requestDetail.request_no}
                                                    dataFile={bylawsEditFile}
                                                  />
                                                ) : (
                                                  <div>-</div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                      </>
                                  )}
                              </>
                          )}
                          {((isShowSection.bylaws_select === "0" ) ||
                            (isShowSection.bylaws_select === "1" && lastNumber > 1)) && (
                            <Row id="section-page-10-4">
                              <Col md={12}>
                                  <div className="section-dashed-line"></div>
                              </Col>
                            </Row>
                          )}
                    </>
                  )}
                  { requestTemplateDetail.cod_select === "1" && (
                    <>
                      <Row id="section-page-11-1">
                            <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("cod_select")}>
                              <i className="mdi mdi-book-open-variant icon-book"></i>
                              <Label className="label-title-topic">เปลี่ยนแปลงรายชื่อกรรมการ และ/หรือเปลี่ยนแปลงกรรมการผู้มีอำนาจลงนามผูกพันบริษัท</Label>
                              <br/>
                              <Label className="label-sub-title-topic">(Amendment of the Directors and/or  the Authorized Directors)</Label>
                            </Col>
                      </Row>
                            { isShowSection.cod_select === "1" && (
                                <>
                                  <Row id="section-page-11-12">
                                      <Col md={12}>
                                        <div className="body-content margin-bottom-10">
                                          <Label className="content-val">1.กรรมการที่ลาออก/พ้นวาระ The resigned / Rotated Director (s)</Label>
                                        </div>
                                      </Col>
                                  </Row>
                                  {requestTemplateDetail.cod_out_select === "1" ?
                                    formCodOut.map((item, index) => (
                                      <Row id={"section-page-11-" + (index + 3)} key={"codOut" + index}>
                                        <Col md={12}>
                                          {item.source === "doc_cod_out" ? RenderCodOut(item, index) : null}
                                        </Col>
                                      </Row>
                                      )
                                    ) : (
                                      <Row id={"section-page-11-4"}>
                                        <Col md={12}>
                                        <div className="body-content">{"-"}</div>
                                        </Col>
                                      </Row>
                                    )
                                  }
                                  <Row id="section-page-11-13">
                                    <Col md={12}>
                                      <div className="dashed-line"></div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-11-14">
                                      <Col md={12}>
                                        <div className="body-content margin-bottom-10">
                                          <Label className="content-val">2.กรรมการที่เข้าใหม่ The New Director(s)</Label>
                                        </div>
                                      </Col>
                                  </Row>
                                  {requestTemplateDetail.cod_add_select === "1" ?
                                    formCodAdd.map((item, index) => (
                                      <Row id={"section-page-11-" + (index + 14)} key={"codAdd" + index}>
                                        <Col md={12}>
                                          {item.source === "doc_cod_add" ? RenderCodAdd(item, index) : null}
                                        </Col>
                                      </Row>
                                      )
                                    ) : (
                                      <Row id={"section-page-11-15"}>
                                        <Col md={12}>
                                          <div className="body-content">{"-"}</div>
                                        </Col>
                                      </Row>
                                    )
                                  }
                                  <Row id="section-page-11-24">
                                    <Col md={12}>
                                      <div className="dashed-line"></div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-11-25">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">3.อำนาจของกรรมการซึ่งลงลายมือชื่อผูกพันบริษัท (ปัจจุบัน)</Label>
                                        <Label className="content-name">(The authority of the current directors)</Label>
                                        <Label className="content-val word-wrap">{requestTemplateDetail.cod_current_powerofdirector || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-11-26">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">4.อำนาจของกรรมการซึ่งลงลายมือชื่อผูกพันบริษัท (ใหม่)</Label>
                                        <Label className="content-name">(The authority of the new directors)</Label>
                                        <Label className="content-val word-wrap" >{requestTemplateDetail.cod_new_powerofdirector || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="section-page-11-27">
                                    <Col md={12}>
                                      <div className="body-content">
                                        <Label className="content-val">5.ระบุเพิ่มเติม</Label>
                                        <Label className="content-name">(Please Specify More Details)</Label>
                                        <Label className="content-val word-wrap">{requestTemplateDetail.cod_remark || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                            )}
                            {((isShowSection.cod_select === "0" ) ||
                              (isShowSection.cod_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-11-28">
                                <Col md={12}>
                                  <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </> 
                  )}
                  { requestTemplateDetail.coa_select === "1" && (
                    <>
                      <Row id="section-page-12-1">
                            <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("coa_select")}>
                              <i className="mdi mdi-book-open-variant icon-book"></i>
                              <Label className="label-title-topic">เรียกชำระค่าหุ้นเพิ่ม</Label>
                              <br/>
                              <Label className="label-sub-title-topic">(Calling of the Additional Share Payment)</Label>
                            </Col>
                      </Row>
                            { isShowSection.coa_select === "1" && (
                                <>
                                      <Col md={12}>
                                        <Row id="section-page-12-2">
                                          <div className="body-content">
                                            <Label className="content-name">1.ราคาค่าหุ้นที่เรียกชำระแล้ว...บาท/หุ้น (Paid-up share price : Baht/Share)</Label>
                                            <Label className="content-val word-wrap">{requestTemplateDetail.coa_share_bath + " บาท/หุ้น" || "-"}</Label>
                                          </div>
                                        </Row>
                                        <Row id="section-page-12-3">
                                          <div className="body-content">
                                            <Label className="content-name">2.จำนวนหุ้นที่จะเรียกชำระ...หุ้น (Number of shares to be called for payment : Shares)</Label>
                                            <Label className="content-val word-wrap">{requestTemplateDetail.coa_share_number + " หุ้น" || "-"}</Label>
                                          </div>
                                        </Row>
                                        <Row id="section-page-12-4">
                                          <div className="body-content">
                                            <Label className="content-name">3.ราคาค่าหุ้นที่เรียกชำระเพิ่ม...บาท/หุ้น (Additional share price : Baht/Share)</Label>
                                            <Label className="content-val word-wrap">{requestTemplateDetail.coa_share_addition + " บาท/หุ้น" || "-"}</Label>
                                          </div>
                                        </Row>
                                        <Row id="section-page-12-5">
                                          <div className="body-content">
                                            <Label className="content-name">4.รวมเป็นจำนวนเงินที่เรียกชำระในครั้งนี้...บาท (The total amount due for this payment : Baht)</Label>
                                            <Label className="content-val word-wrap">{requestTemplateDetail.coa_share_total + " บาท" || "-"}</Label>
                                          </div>
                                        </Row>
                                        <Row id="section-page-12-6">
                                          <div className="body-content">
                                            <Label className="content-name">5.วันที่ชำระค่าหุ้นเพิ่ม (Payment date)</Label>
                                            <Label className="content-val word-wrap">{ ConvertFormatDate(requestTemplateDetail?.coa_share_date) || "-"}</Label>
                                          </div>
                                        </Row>
                                      </Col>
                                </>
                            )}
                            {((isShowSection.coa_select === "0" ) ||
                              (isShowSection.coa_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-12-7">
                                <Col md={12}>
                                  <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
                  { requestTemplateDetail.ts_select === "1" && (
                    <>
                      <Row id="section-page-13-1">
                          <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("ts_select")}>
                            <i className="mdi mdi-book-open-variant icon-book"></i>
                            <Label className="label-title-topic">โอนหุ้น</Label>
                            <br/>
                            <Label className="label-sub-title-topic">(Share Transfer)</Label>
                          </Col>
                      </Row>
                      {isShowSection.ts_select === "1" &&
                        formTsCtp.map((item, index) => (
                          <Row id={"section-page-13-" + (index + 2)} key={"tsCtp" + index}>
                            <Col md={12}>
                              {item.source === "doc_ctp" ? RenderTsCtp(item, index) : null}
                            </Col>
                          </Row>
                        ))
                      }
                      {((isShowSection.ts_select === "0" ) ||
                        (isShowSection.ts_select === "1" && lastNumber > 1)) && (
                        <Row id="section-page-13-7">
                          <Col md={12}>
                            <div className="section-dashed-line"></div>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                  { requestTemplateDetail.dtc_select === "1" && (
                    <>
                      <Row id="section-page-14-1">
                          <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("dtc_select")}>
                            <i className="mdi mdi-book-open-variant icon-book"></i>
                            <Label className="label-title-topic">เลิกบริษัท</Label>
                            <br/>
                            <Label className="label-sub-title-topic">(Company Liquidation)</Label>
                          </Col>
                      </Row>
                          { isShowSection.dtc_select === "1" && (
                              <>
                                    <Col md={12}>
                                      {[...Array(5)].map((_, index) => {
                                        const key = `dtc_liquidator_${index + 1}`;
                                        const value = requestTemplateDetail[key];

                                        // เช็คว่า value มีค่าหรือไม่
                                        if (!value) return null;

                                        return (
                                          <Row key={`section-page-14-${index + 2}`} id={`section-page-14-${index + 2}`}>
                                            <div className="body-content">
                                              {/* บรรทัดแรกมีหัวข้อใหญ่ */}
                                              {index === 0 && (
                                                <Label className="content-val">
                                                  1.ชื่อ-นามสกุลผู้ชำระบัญชี The name of the liquidator(s)
                                                </Label>
                                              )}
                                              <Label className="content-name">
                                                1.{index + 1} คำนำหน้า ชื่อและนามสกุล (Name-Surname)
                                              </Label>
                                              <Label className="content-val word-wrap">{value}</Label>
                                            </div>
                                          </Row>
                                        );
                                      })}
                                      <Row id="section-page-14-7">
                                        <div className="body-content">
                                          <Label className="content-val">2. อำนาจผู้ชำระบัญชี The power of the liquidator(s)</Label>
                                          <Label className="content-name">The power of the liquidator(s)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.dtc_powerofliquidator || "-"}</Label>
                                        </div>
                                      </Row>
                                      <Row id="section-page-14-8">
                                        <div className="body-content">
                                          <Label className="content-val">3. สำนักงานผู้ชำระบัญชี The office(s) of the liquidator(s)</Label>
                                          <Label className="content-name">The office(s) of the liquidator(s)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.dtc_liquidatoroffice_name || "-"}</Label>
                                        </div>
                                      </Row>
                                      <Row id="section-page-14-9">
                                        <div className="body-content">
                                          <Label className="content-val">4. ทะเบียนบ้านสำนักงานผู้ชำระบัญชี</Label>
                                          <Label className="content-name">แนบไฟล์ทะเบียนบ้านสำนักงานผู้ชำระบัญชี the copy(.pdf) of the House Registration of the office(s) of liquidator(s)</Label>
                                          <Label className="content-val">
                                          {dtcLiquidatorofficeFile.length > 0 ? (
                                            <MultipleDownloadfile
                                              folder={requestDetail.request_no}
                                              dataFile={dtcLiquidatorofficeFile}
                                            />
                                          ) : (
                                            <div>-</div>
                                          )}
                                          </Label>
                                        </div>
                                      </Row>
                                      {[...Array(5)].map((_, index) => {
                                        const key = `dtc_auditor_${index + 1}`;
                                        const value = requestTemplateDetail[key];

                                        if (!value) return null;

                                        return (
                                          <Row key={`section-page-14-${index + 10}`} id={`section-page-14-${index + 8}`}>
                                            <div className="body-content">
                                              {index === 0 && (
                                                <Label className="content-val">
                                                  5.ชื่อ-นามสกุลผู้สอบบัญชี The name of the auditor(s)
                                                </Label>
                                              )}
                                              <Label className="content-name">
                                                5.{index + 1} ชื่อ-นามสุกล (Name-Surname)
                                              </Label>
                                              <Label className="content-val word-wrap">{value}</Label>
                                            </div>
                                          </Row>
                                        );
                                      })}
                                      <Row id="section-page-14-15">
                                        <div className="body-content">
                                          <Label className="content-val">6. ชื่อสำนักงานของผู้สอบบัญชี</Label>
                                          <Label className="content-name">The name of the auditor's office</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.dtc_auditoroffice || "-"}</Label>
                                        </div>
                                      </Row>
                                      <Row id="section-page-14-16">
                                        <div className="body-content">
                                          <Label className="content-val">7. ค่าสินจ้างผู้สอบบัญชี/บาท (The audit fee/Baht)</Label>
                                          <Label className="content-name">The audit fee/Baht</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.dtc_auditorfee + " บาท" || "-"}</Label>
                                        </div>
                                      </Row>
                                    </Col>
                                </>
                            )}
                            {((isShowSection.dtc_select === "0" ) ||
                              (isShowSection.dtc_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-14-17">
                                <Col md={12}>
                                  <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
                  { requestTemplateDetail.col_select === "1" && (
                    <>
                      <Row id="section-page-15-1">
                          <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("col_select")}>
                            <i className="mdi mdi-book-open-variant icon-book"></i>
                            <Label className="label-title-topic">เสร็จการชำระบัญชี</Label>
                            <br/>
                            <Label className="label-sub-title-topic">(The Completeness of Liquidation)</Label>
                          </Col>
                      </Row>
                            { isShowSection.col_select === "1" && (
                                <>
                                    <Row id="section-page-15-2">
                                      <Col md={12}>
                                        <div className="body-content">
                                            <Label className="content-val">1.งบดุลวันที่เลิกบริษัท</Label>
                                            <Label className="content-name">The copy of the House Registration of the office(s) of liquidator(s)</Label>
                                            <Label className="content-val">
                                            {colBalancesheetFile.length > 0 ? (
                                              <MultipleDownloadfile
                                                folder={requestDetail.request_no}
                                                dataFile={colBalancesheetFile}
                                              />
                                            ) : (
                                              <div>-</div>
                                            )}
                                            </Label>
                                        </div>
                                        <div className="body-content">
                                            <Label className="content-val">2.เอกสารรายการสมุดบัญชีและสรรพเอกสารทั้งหลาย</Label>
                                            <Label className="content-name">The file specifying the list of the account books and any</Label>
                                            <Label className="content-val">
                                            {colDocsFile.length > 0 ? (
                                              <MultipleDownloadfile
                                                folder={requestDetail.request_no}
                                                dataFile={colDocsFile}
                                              />
                                            ) : (
                                              <div>-</div>
                                            )}
                                            </Label>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row id="section-page-15-3">
                                      <Col md={12}>
                                        { requestTemplateDetail.col_docs_ship_date ? (
                                          <div className="body-content">
                                            <Label className="content-val">นำส่งต้นฉบับงบดุลวันที่เลิกบริษัทให้ฝ่ายกฎหมายแล้ว เมื่อวันที่ </Label>
                                            <Label className="content-name">วันที่นำส่งเอกสาร</Label>
                                            <Label className="content-val word-wrap">{ConvertFormatDateSlash(requestTemplateDetail.col_docs_ship_date) || "-"}</Label>
                                          </div>
                                        ) : (
                                          <div className="body-content">
                                            <Label className="content-val">จะจัดส่งต้นฉบับงบดุลวันที่เลิกบริษัทให้ฝ่ายกฎหมาย ในวันที่  เมื่อวันที่ </Label>
                                            <Label className="content-name">วันที่จะจัดส่ง</Label>
                                            <Label className="content-val word-wrap">{ConvertFormatDateSlash(requestTemplateDetail.col_docs_sent_date) || "-"}</Label>
                                          </div>
                                        )}
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {((isShowSection.col_select === "0" ) ||
                              (isShowSection.col_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-15-4">
                                <Col md={12}>
                                  <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
                  { requestTemplateDetail.other_select === "1" && (
                    <>
                      <Row id="section-page-16-1">
                        <Col md={12} className="header-content section-click" onClick={() => toggleCheckbox("other_select")}>
                          <i className="mdi mdi-book-open-variant icon-book"></i>
                          <Label className="label-title-topic">อื่นๆ</Label>
                          <br/>
                          <Label className="label-sub-title-topic">(Others)</Label>
                        </Col>
                      </Row>
                          { isShowSection.other_select === "1" && (
                              <>
                                  <Row id="section-page-16-2">
                                    <Col md={12}>
                                      <div className="body-content">
                                          <Label className="content-name">1.ชื่อเรื่อง (Title)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.other_title || "-"}</Label>
                                      </div>
                                      <div className="body-content">
                                          <Label className="content-name">2.รายละเอียดเพิ่มเติมให้ชัดเจน (Please specify complete information)</Label>
                                          <Label className="content-val word-wrap">{requestTemplateDetail.other_detail || "-"}</Label>
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                            )}
                            {((isShowSection.other_select === "0" ) ||
                              (isShowSection.other_select === "1" && lastNumber > 1)) && (
                              <Row id="section-page-16-conditional">
                                <Col md={12}>
                                  <div className="section-dashed-line"></div>
                                </Col>
                              </Row>
                            )}
                    </>
                  )}
              
              {/* <div id="section-page-16-1"> */}
              <Row id="section-page-17-1">
                <div className="header-content">
                  อื่นๆ (Others)
                </div>
              </Row>
              <Row id="section-page-17-2">
                <Col md={12}>
                    <div className="dashed-line"></div>
                </Col>
              </Row>
                  <Row id="section-page-17-3">
                    <Col md={12}>
                      <div className="body-content-pdf">
                      <Label className="content-name">
                        ระดับชั้นความลับ (Confidentiality Level)
                      </Label>
                      <Label className="content-val word-wrap">
                        { requestTemplateDetail.name_confidential_level_en || "-"}
                      </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row id="section-page-17-4">
                    <Col md={12}>
                      <div className="body-content-pdf">
                        <Label className="content-name">
                          ความเห็นของ User (User's Comment)
                        </Label>
                        <Label className="content-val word-wrap">
                          {requestTemplateDetail.user_comment || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row id="section-page-17-5">
                    <Col md={12}>
                      <div className="body-content-pdf">
                        <Label className="content-name">
                          ชื่อนักกฎหมายที่เคยตรวจเอกสารนี้ (Legal team who has handled
                          this work)
                        </Label>
                        <Label className="content-val">
                          {requestDetail.require_handled_by || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row id="section-page-17-6">
                    <Col md={12}>
                      <div className="body-content-pdf">
                        <Label className="content-name">
                          ผู้อนุมัติแบบคำขอ (User Approver)
                        </Label>
                        <Label className="content-val">
                          {requestDetail.approve_request_by || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
            </div>
            </DownloadPDF>
          </Col>
        </Row>
    </React.Fragment>
  );
};

export default AssignDetailDbd;
